/* eslint-disable */
import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';
import "@fr/pages/desktop/travelata/default-application/static/styles/static-page.scss"
import "./styles/static-page-agreement.css"
